<template>
  <div
      :class="{ 'comment-right': userId !== comment.user_id }"
      class="comment"
  >
    <figure>
      <img :src="comment.user.avatar_fallback" alt="" class="img-circle img-avatar">
    </figure>
    <div style="max-width: calc(100% - 75px);">
      <div>
        <div
            :inner-html.prop="($options.filters.nl2br(linkify(comment.comment)))"
            style="word-wrap: break-word;"
        ></div>

        <ul class="list-unstyled" v-if="comment.media.length > 0">
          <li v-for="file in comment.media">
            <a :href="file.full_url" target="_blank" v-if="file">
              <span class="badge">{{ file.mime_type }}</span>
              {{ file.file_name }}
            </a>

            <span v-if="userRole === 'admin'"> &bull; </span>

            <a v-if="userRole === 'admin'" href="#" @click.prevent="removeFile(comment, file)">Verwijder</a>
          </li>
        </ul>
      </div>

      <p>
        <small>
          {{ comment.user.name }} &bull; {{ $moment(comment.created_at).format('D-M-YYYY HH:mm:ss') }}
          <template v-if="userRole === 'admin'">
            &bull; {{ comment.type_title }} &bull;
            <a v-if="changeComment" href="#" @click.prevent="editComment(comment.id)">Wijzig</a> <span v-if="changeComment">&bull;</span>
            <a href="#" @click.prevent="removeComment(comment)">Verwijder</a>
          </template>
        </small>
      </p>
    </div>

    <modal ref="modal">
      <span slot="header">Wijzig opmerking</span>

      <form method="post" @submit.prevent="onChangeComment">
        <div class="form-group">
          <label class="control-label">Opmerking</label>
          <textarea required name="comment" id="comment" class="form-control" rows="5" :value="comment.comment" ref="editComment"></textarea>
        </div>

        <div class="form-group">
          <label class="control-label">Zichtbaarheid aanpassen</label>
          <select class="form-control" name="type" :value="comment.type" ref="editVisibility">
            <option value="1">Klant</option>
            <option value="2">Chauffeur</option>
            <option value="3">Openbaar</option>
            <option value="4">Intern</option>
          </select>
        </div>

        <div class="form-group">
          <button type="submit" class="btn btn-primary">Opslaan</button>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import Autolinker from 'autolinker';

export default {
  name: "JobComment",

  props: {
    userId: {
      type: Number,
      required: true,
    },

    userRole: {
      type: String,
      required: true,
    },

    comment: {
      type: Object,
      required: true,
    },

    changeComment: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    editComment(commentId) {
      this.$refs.modal.open();
    },

    onChangeComment(event) {
      const comment = this.$refs.editComment.value;
      const type = this.$refs.editVisibility.value;
      const typeTitle = this.$refs.editVisibility.options[this.$refs.editVisibility.selectedIndex].text;

      this.$http.post(`/admin/jobcomments/save/${this.comment.id}`, {
        comment,
        type,
      }).then(response => {
        this.$refs.modal.close();

        this.comment.comment = comment;
        this.comment.type = type;
        this.comment.type_title = typeTitle;

        notify({
          title: `Bericht gewijzigd`,
          text: `Het bericht is gewijzigd.`,
          type: 'success',
        });
      });
    },    

    removeComment(comment) {
      this.$swal({
        title: 'Bericht verwijderen',
        text: `Weet je zeker dat je het bericht van "${comment.user.name}" wilt verwijderen?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, verwijder',
        cancelButtonText: 'Nee, annuleren',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/admin/jobcomments/delete/${comment.id}`).then(() => {
            notify({
              title: `Bericht verwijderd`,
              text: `Het bericht is verwijderd.`,
              type: 'success',
            });
          });

          this.$emit('delete', comment.id);
        }
      });
    },

    removeFile(comment, file) {
      this.$swal({
        title: 'Bestand verwijderen',
        text: `Weet je zeker dat je het bestand wilt verwijderen?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, verwijder',
        cancelButtonText: 'Nee, annuleren',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.delete(`/admin/jobcomments/deletefile/${file.id}`).then(() => {
            notify({
              title: `Bestand verwijderd`,
              text: `Het bestand is verwijderd.`,
              type: 'success',
            });
          });

          comment.media = comment.media.filter(media => media.id !== file.id);
        }
      });
    },

    linkify (msg) {
      if (msg) {
        return Autolinker.link(msg);
      }

      return ''
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Job/Comments/Comment.vue